import {
  ButtonGroup,
  ButtonGroupCloseColorEnum,
  ButtonGroupCornerEnum,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { REVIEW_STATES } from '@/constants';
import { useParrillaFilters } from '@/stores/parrilla-filters';

export function BroadcastScheludeHeaderSeenFilter() {
  const { review_state, setFilters } = useParrillaFilters();
  const { t } = useTranslation();

  const handleReviewStateChange = (state: number) => {
    if (review_state.includes(state)) {
      setFilters({ review_state: review_state.filter(p => p !== state) });
    } else {
      setFilters({ review_state: [...review_state, state] });
    }
  };
  return (
    <div className="flex items-center gap-2">
      {REVIEW_STATES.map(item => (
        <Tooltip help={t(item.label)} key={item.value} grow>
          <ButtonGroup
            size={ButtonSizeEnum.SM}
            onClick={() => handleReviewStateChange(item.value)}
            onClickClose={() => handleReviewStateChange(item.value)}
            closeColor={ButtonGroupCloseColorEnum.PRIMARY}
            isFilled={review_state.includes(item.value)}
            corner={ButtonGroupCornerEnum.FULL}
            className={clsx(
              'hover:!bg-neutral-20',
              review_state.includes(item.value)
                ? '!border-[2px] !border-accent-active-primary-20 bg-extra-new-95'
                : '!border'
            )}
            closeIcon={review_state.includes(item.value)}
          >
            <Typography
              fontSize={FontSizeEnum.Basic}
              weight={FontWeightEnum.Semibold}
              color={FontColorEnum.Dark10}
            >
              {<item.icon size={IconSizeEnum.SM} className={item.color} />}
            </Typography>
          </ButtonGroup>
        </Tooltip>
      ))}
    </div>
  );
}
